/**
 * Props for an element that shows customer text (a file name, a clause, a typed search): no analytics tool may
 * record it (D41, D59). One spread keeps the three marks together, because each tool honours only its own:
 *  - `ph-no-capture`: PostHog autocapture and replay, and Mixpanel's session replay (its default block class)
 *  - `mp-no-track`: Mixpanel autocapture, which would otherwise send the `aria-label`, `title` and `id` of every
 *    element in the click path (`capture_text_content: false` only covers the visible text)
 *  - `data-clarity-mask="True"`: Microsoft Clarity recordings
 *
 * Use: `<Box {...maskedContent} />`. The marks cover everything inside the element.
 */
export const maskedContent = {
  className: "ph-no-capture mp-no-track",
  "data-clarity-mask": "True",
} as const;

export default maskedContent;
